//Copyright 2018 Nathan Moore

export const SET_PATHWAY = "SET_PATHWAY";
